/*
 * attachment-type (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { attachmentTypes } from "./attachment-type.schema"

/* Select */
export type AttachmentType = z.infer<typeof selectAttachmentTypeSchema>
export const selectAttachmentTypeSchema = createSelectSchema(attachmentTypes)

/* Filters */
export type AttachmentTypeFilters = z.infer<typeof attachmentTypeFiltersSchema>
export const attachmentTypeFiltersSchema = z.object({
	id: z.string().optional(),
	name: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createAttachmentTypeSchema = createInsertSchema(attachmentTypes, {
	name: z.string().min(1, "Name is required"),
}).partial(globalCreateExclude)
export type CreateAttachmentType = z.infer<typeof createAttachmentTypeSchema>

/* Update */
export const updateAttachmentTypeSchema = createInsertSchema(attachmentTypes)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateAttachmentType = z.infer<typeof updateAttachmentTypeSchema>
